import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

import { animation, colors } from '../../config';

const ErrorText = styled.label`
  font-size: 12px;
  color: ${colors.alert.error};
  padding: 0 14px;
  transition: ${animation.transition};
  position: absolute;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transform: ${({ visible }) =>
    visible ? 'transform: translateY(0);' : 'translateY(-6px)'};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  z-index: 1;
`;

export default function FieldError({ error = '', htmlFor }) {
  const [visible, setVisible] = useState(false);
  const [errorState, setErrorState] = useState(error);

  const handleTransitionEnd = useCallback(() => {
    if (!visible) {
      setErrorState('');
    }
  }, [visible, setErrorState]);

  useEffect(() => {
    if (!error) {
      setVisible(false);
      return;
    }

    setErrorState(error);
    setVisible(true);
  }, [error, setVisible, setErrorState]);

  return (
    <ErrorText
      visible={visible}
      onTransitionEnd={handleTransitionEnd}
      htmlFor={htmlFor}
    >
      {errorState}
    </ErrorText>
  );
}
